import * as Sentry from "@sentry/vue";
import { createGtag, event as gtagEvent } from 'vue-gtag';

const sentryUrl = import.meta.env.VITE_SENTRY_URL;
const isProduction = import.meta.env.PROD;

export function registerSentryErrorHandling(app, router) {
  if (sentryUrl) {
    Sentry.init({
      app,
      dsn: sentryUrl,
      // Adds request headers and IP for users, for more info visit:
      // https://docs.sentry.io/platforms/javascript/guides/vue/configuration/options/#sendDefaultPii
      sendDefaultPii: true,
      integrations: [
        // Or omit `router` if you're not using vue-router
        Sentry.browserTracingIntegration({ router }),
      ],
    });

    window.addEventListener('unhandledrejection', (event) => {
      // Prevent the default handling (e.g., console.error in some browsers)
      event.preventDefault();

      const error = event.reason;
      Sentry.captureException(error);

      // throw error;
    });
  }
}

export function registerGTagErrorHandling(app, router) {
  // disable the tracking for dev and test environments
  if (isProduction) {
    const gtag = createGtag({
      tagId: 'G-D62M7DQW03',
      // Automatic page fields must not attach share/embed credentials or media titles to Cast events.
      config: {
        page_location: window.location.origin,
        page_referrer: window.location.origin,
        page_title: 'TubeWay',
      },
      pageTracker: {
        router,
        useScreenview: true,
        template: () => ({
          screen_name: 'TubeWay',
          app_name: 'TubeWay',
          page_location: window.location.origin,
          page_referrer: window.location.origin,
          page_title: 'TubeWay',
        }),
      },
    });

    window.addEventListener('unhandledrejection', (event) => {
      // Prevent the default handling (e.g., console.error in some browsers)
      event.preventDefault();

      const error = event.reason;
      const description = error instanceof Error ? error.message : String(error);

      // Send error info as an event to Google Analytics via vue-gtag
      gtagEvent('exception', {
        description: `Unhandled Promise Rejection: ${description}`,
        fatal: false // Unhandled rejections are typically fatal if not explicitly caught
      });

      // console.error('Unhandled Promise Rejection:', error);
    });

    app.use(gtag);
  }
}

export function handleError(err, info) {
  if (sentryUrl) {
    Sentry.captureException(err);
  }

  if (isProduction) {
    gtagEvent('exception', {
      description: `${err.message} - ${info}`,
      fatal: false
    });
  }
}
